import { render, staticRenderFns } from "./CusDocList.vue?vue&type=template&id=39fe2bd0&scoped=true&"
import script from "./CusDocList.vue?vue&type=script&lang=js&"
export * from "./CusDocList.vue?vue&type=script&lang=js&"
import style0 from "./CusDocList.vue?vue&type=style&index=0&id=39fe2bd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe2bd0",
  null
  
)

export default component.exports